import React, { useContext, useEffect, useRef, useState } from "react"
import {
  Collapse,
  Button,
  Card,
  CardBody,
  CardTitle,
  UncontrolledAlert,
  Col,
  Row,
  Label,
} from "reactstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Drawer, Steps, Select, Input as AntdInput } from "antd"

import {
  getClientData,
  getVideoCallToken,
  resolveAlarms,
  ackAlarms,
} from "../../../helpers/backend_helper"
import { formatDateFull, showToast } from "utils/general"
import { Link } from "react-router-dom"
import GlobalState from "contexts/GlobalState"
import withRouter from "components/Common/withRouter"
const { TextArea } = AntdInput;

const AlarmMonitoringDrawer = props => {
  const [state] = useContext(GlobalState)
  const [propsTemp, setPropsTemp] = useState()
  const [status, setStatus] = useState(0)
  const [showAlarmStatus, setShowAlarmStatus] = useState(false)
  const [manageAlarmCollapse, setManageAlarmCollapse] = useState(false)
  const [alert, setAlert] = useState(false)
  const [ongoingAction, setOngoingAction] = useState(false)

  // Alert settings content
  const [alarmKey, setAlarmKey] = useState()
  const [newMessage, setNewMessage] = useState("")
  const [cause, setCause] = useState("")
  const [action, setAction] = useState("")
  const [falseAlarm, setFalseAlarm] = useState(false)
  const [continueAlarm, setContinueAlarm] = useState(false)

  // Selected client states
  const [selectedClient, setSelectedClient] = useState()
  const [clientInfo, setClientInfo] = useState([])
  const [showInfo, setShowInfo] = useState(false)

  const [reasons, setReasons] = useState([])
  const reasonCodes = [
    "R000",
    "R001",
    "R010",
    "R020",
    "R030",
    "R040",
    "R050",
    "R060",
    "R070",
    "R071",
    "R080",
    "R090",
    "R100",
    "R110",
    "R120",
    "R130",
    "R131",
    "R140",
    "R150",
    "R160",
    "R170",
    "R180",
    "R190",
    "R200",
  ]

  const [actions, setActions] = useState([])
  const actionCodes = [
    "A000",
    "A001",
    "A010",
    "A020",
    "A030",
    "A031",
    "A032",
    "A033",
  ]

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()

    let temp = []
    for (const code of reasonCodes) {
      temp.push({
        id: code,
        value: code,
        label: props.t("AlarmReasons." + code),
      })
    }
    setReasons(temp)

    return () => abortRef.current.abort()
  }, [])

  // Set reasons and actions options translated
  useEffect(() => {
    if (props.showDrawer) {
      let temp = []
      for (const code of reasonCodes) {
        temp.push({
          id: code,
          value: code,
          label: props.t("AlarmReasons." + code),
        })
      }
      temp.sort((a, b) => (a.label > b.label ? 1 : -1))
      temp.unshift({ id: "undefined", value: "", label: props.t("Undefined") })
      setReasons(temp)

      let temp2 = []
      for (const code of actionCodes) {
        temp2.push({
          id: code,
          value: code,
          label: props.t("AlarmActions." + code),
        })
      }
      temp2.sort((a, b) => (a.label > b.label ? 1 : -1))
      temp2.unshift({ id: "undefined", value: "", label: props.t("Undefined") })
      setActions(temp2)
    }
  }, [props.showDrawer])

  useEffect(() => {
    if (props.selectedRow != undefined && props.selectedRow != propsTemp) {
      // console.log(props.selectedRow, props.showDrawer, "selectedRow")
      setAlarmKey(props.selectedRow.key)
      setSelectedClient(props.selectedRow.client_key)
      setPropsTemp(props.selectedRow)
      setManageAlarmCollapse(false)
      setAlert(false)
      if (props.showDrawer) {
        // console.log(props)
        setShowAlarmStatus(true)

        let username
        if (state.authUser != null) {
          const obj = JSON.parse(state.authUser)
          username = obj.username
        }

        if (props.selectedRow.status == "UNASSIGNED") {
          setStatus(0)
        }
        if (props.selectedRow.status == "ASSIGNED") {
          setStatus(1)
          if (
            !props.selectedRow.lockedToUser ||
            (props.selectedRow.lockedToUser &&
              props.selectedRow.acked_by_username == username)
          ) {
            setManageAlarmCollapse(true)
          }
        }
        if (props.selectedRow.status == "CLOSED") {
          setStatus(2)
        }
        if (!props.selectedRow.status) {
          setStatus(2)
        }
      }
    }
  }, [props.selectedRow])

  // Fetch client data
  useEffect(() => {
    setShowInfo(false)
    if (selectedClient !== undefined) {
      getClientData(abortRef.current, selectedClient, false)
        .then(result => {
          console.log(result)
          setClientInfo(result)
          setShowInfo(true)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => { })
    }
  }, [selectedClient])

  const settingFalseAlarm = e => {
    e.persist()
    setFalseAlarm(prevState => !prevState)
  }

  const settingContinueAlarm = e => {
    e.persist()
    setContinueAlarm(prevState => !prevState)
  }

  // Handling the alarm
  const manageAlarm = () => {
    setOngoingAction(true)
    let alarms = [alarmKey]
    ackAlarms(abortRef.current, alarms)
      .then(result => {
        console.log(result)
        if (result.length == 1 && result[0].result == "OK") {
          setManageAlarmCollapse(true)
          setStatus(1)
          props.setUpdateRequired(true)
        } else {
          showToast(props.t("Error"), "error", 8000)
        }
      })
      .catch(err => {
        console.log(err)
        showToast(props.t("Error"), "error", 8000)
      })
      .finally(() => {
        setOngoingAction(false)
      })
  }

  // Closing alarm
  const closeAlarm = () => {
    setOngoingAction(true)
    let alarms = [alarmKey]
    resolveAlarms(
      abortRef.current,
      alarms,
      newMessage,
      falseAlarm,
      cause,
      action,
      continueAlarm
    )
      .then(result => {
        console.log(result)
        if (result.length == 1 && result[0].result == "OK") {
          setAlert(true)
          // TODO: DELETE
          setStatus(2)
          setManageAlarmCollapse(false)
          props.setUpdateRequired(true)
        } else {
          showToast(props.t("Error"), "error", 8000)
        }
      })
      .catch(err => {
        console.log(err)
        showToast(props.t("Error"), "error", 8000)
      })
      .finally(() => {
        setOngoingAction(false)
      })
  }

  const onChange = value => {
    // onChange does not work, but has to be included in checkbox
    // console.log(value, "checkbox is alive")
  }

  // Start video call
  const startVideoCall = () => {
    getVideoCallToken(abortRef.current, props.selectedRow.client_key)
      .then(result => {
        if (result.link != null && result.link.length > 0) {
          globalThis.open(result.link, "_blank", "noreferrer")
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <>
      <Drawer
        title=""
        width="780px"
        placement="right"
        onClose={() => {
          props.setShowDrawer(false)
        }}
        open={props.showDrawer}
        zIndex={1003}
      //bodyStyle={{ backgroundColor: "#f8f8f8" }}
      >
        <CardTitle>
          <i className="bx bxs-bell-ring text-truncate align-middle me-2"></i>
          {props.t("Alarm status")}
        </CardTitle>
        {showAlarmStatus && (
          <Card>
            <CardBody style={{ paddingBottom: "0px" }}>
              <Row>
                <Col sm={7}>
                  <Steps
                    className="steps-custom"
                    style={{ height: "230px" }}
                    size="small"
                    current={status}
                    direction="vertical"
                    items={[
                      {
                        title: props.t("Alarm received"),
                        icon: (
                          <i className="mdi mdi-arrow-collapse-down color-primary"></i>
                        ),
                        subTitle: props.selectedRow.received_at ? (
                          <span>
                            {formatDateFull(props.selectedRow.received_at)}
                          </span>
                        ) : (
                          <span></span>
                        ),
                        description: props.selectedRow.acked_by ? (
                          <span></span>
                        ) : (
                          <>
                            {/* TODO: DELETE THIS AND UPDATE PROPS /  */}
                            {manageAlarmCollapse === false && status === 0 && (
                              <button
                                type="button"
                                disabled={ongoingAction}
                                className="btn btn-outline-primary mb-2 mt-1"
                                onClick={() => {
                                  manageAlarm()
                                }}
                              >
                                {props.t("Handle the alarm")}
                              </button>
                            )}
                          </>
                        ),
                      },
                      {
                        title: props.t("Alarm acknowledged"),
                        icon: (
                          <i className="bx bx-rotate-right color-primary"></i>
                        ),
                        subTitle: props.selectedRow.acked_at ? (
                          <span>
                            {formatDateFull(props.selectedRow.acked_at)}
                          </span>
                        ) : (
                          <span></span>
                        ),
                        description: props.selectedRow.acked_by ? (
                          <span>
                            <i className="bx bx-user me-1" />
                            {props.selectedRow.acked_by}
                          </span>
                        ) : (
                          <span></span>
                        ),
                      },
                      {
                        title: props.t("Alarm closed"),
                        icon: (
                          <i className="bx bxs-check-circle color-primary"></i>
                        ),
                        subTitle: props.selectedRow.closed_at ? (
                          <span>
                            {formatDateFull(props.selectedRow.closed_at)}
                          </span>
                        ) : (
                          <span></span>
                        ),
                        description: props.selectedRow.closed_by ? (
                          <span>
                            <i className="bx bx-user me-1" />
                            {props.selectedRow.closed_by}
                          </span>
                        ) : (
                          <span></span>
                        ),
                      },
                    ]}
                  ></Steps>
                </Col>
                <Col sm={5}>
                  <h5 className="mt-1 me-3">
                    {props.t(props.selectedRow.description)}
                  </h5>
                  <div className="mt-4 h6 text-muted">
                    <i className="bx bxs-user-circle me-1"></i>
                    {props.selectedRow.client}
                  </div>
                  <div className="h6 text-muted">
                    <i className="mdi mdi-account-group me-1"></i>
                    {props.selectedRow.group}
                  </div>
                  <div>
                    {status === 0 && (
                      <span className="badge bg-danger font-size-12 p-2">
                        <i className="mdi mdi-alert-circle-outline"></i>{" "}
                        {props.t("Unassigned")}
                      </span>
                    )}
                    {status === 1 && (
                      <span className="badge bg-warning font-size-12 p-2">
                        <i className=" mdi mdi-alert-circle-outline"></i>{" "}
                        {props.t("Assigned")}
                      </span>
                    )}
                    {status === 2 && (
                      <span className="badge bg-success font-size-12 p-2">
                        <i className="bx bx-check-circle"></i>{" "}
                        {props.t("Alarm closed")}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
        {alert === true && (
          <UncontrolledAlert color="success">
            {props.t("The alarm was closed successfully!")}
          </UncontrolledAlert>
        )}
        <Collapse isOpen={manageAlarmCollapse}>
          <div className="">
            <CardTitle>
              <i className="mdi mdi-bell-check text-truncate align-middle me-2"></i>
              {props.t("Alarm management")}
            </CardTitle>
            <Card>
              <CardBody>
                {/* <hr className="mt-0"></hr> */}
                <Row className="mt-0">
                  <Col sm={6}>
                    <Label>{props.t("Cause of the alarm")}</Label>
                    <div>
                      <Select
                        style={{ width: "100%" }}
                        value={cause}
                        onChange={v => {
                          setCause(v)
                        }}
                        options={reasons}
                      />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <Label>{props.t("Actions")}</Label>
                    <div>
                      <Select
                        style={{ width: "100%" }}
                        value={action}
                        onChange={v => {
                          setAction(v)
                        }}
                        options={actions}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Label className="mt-3">{props.t("Comment")}</Label>
                  </Col>
                  <Col sm={7}>
                    <TextArea
                      allowClear
                      showCount
                      maxLength={500}
                      autoSize={{ minRows: 2, maxRows: 10 }}
                      placeholder={props.t("Optional")}
                      value={newMessage}
                      onChange={(v) => { setNewMessage(v.target.value) }}
                    />
                  </Col>
                  <Col sm={5}>
                    <div className="mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input checkbox "
                        id="checkbox_0"
                        name="checkboxFalse"
                        checked={falseAlarm}
                        onClick={settingFalseAlarm}
                        onChange={onChange}
                      />
                      <label
                        className="form-check-label ms-1"
                        htmlFor="checkbox_0"
                      >
                        {props.t("False alarm")}
                      </label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        className="form-check-input checkbox "
                        id="checkbox_1"
                        name="checkboxContinue"
                        checked={continueAlarm}
                        onClick={settingContinueAlarm}
                        onChange={onChange}
                      />
                      <label
                        className="form-check-label ms-1 text-truncate"
                        htmlFor="checkbox_1"
                      >
                        {props.t("Create handover alarm")}
                      </label>
                    </div>
                  </Col>
                </Row>
                <Col lg={12} className="mt-3">
                  <Button
                    color="primary"
                    className="float-end"
                    disabled={ongoingAction}
                    onClick={() => {
                      closeAlarm()
                    }}
                  >
                    {props.t("Close alarm")}
                  </Button>
                </Col>
              </CardBody>
            </Card>{" "}
          </div>
        </Collapse>
        {showInfo ? (
          <>
            {clientInfo ? (
              <>
                <CardTitle>
                  {props.selectedRow != undefined && (
                    <span className="float-end">
                      <Link
                        className="h6"
                        target="_blank"
                        to={`/clients/${props.selectedRow.client_key}`}
                      >
                        {props.t("Move to customer's management")}
                        <i className="bx bx-right-arrow-alt ms-1"></i>
                      </Link>
                    </span>
                  )}

                  <i className="bx bxs-user-circle text-truncate align-middle me-2"></i>
                  {props.t("Customer profile")}
                </CardTitle>
                <Card>
                  <CardBody>
                    <Row>
                      <Col xs={6} className="mt-1 mb-3">
                        <h6>{props.t("Name")}</h6>
                        <p>{clientInfo.name}</p>
                      </Col>
                      {clientInfo.ssn != "" && clientInfo.ssn && (
                        <Col xs={6} className="mt-1  mb-3">
                          <h6>{props.t("SSN")}</h6>
                          <p>{clientInfo.ssn}</p>
                        </Col>
                      )}
                      {clientInfo.address != "" && clientInfo.address && (
                        <Col xs={6} className="mt-1  mb-3">
                          <h6>{props.t("Address")}</h6>
                          <p className="mb-1">{clientInfo.address} </p>
                          {clientInfo.coordinates ? (
                            <div>
                              <i className="mdi mdi-google-maps me-1 text-primary"></i>
                              <a
                                href={
                                  "https://www.google.com/maps/place/" +
                                  clientInfo.coordinates.latitude +
                                  "," +
                                  clientInfo.coordinates.longitude
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                {props.t("Open in Google Maps")}
                              </a>
                            </div>
                          ) : (
                            <></>
                          )}
                        </Col>
                      )}
                      {clientInfo.gsmNumber != "" && clientInfo.gsmNumber && (
                        <Col xs={6} className="mt-1 mb-3">
                          <h6>{props.t("Phone")}</h6>
                          <a href={"tel:" + clientInfo.gsmNumber}>
                            {clientInfo.gsmNumber}
                          </a>
                        </Col>
                      )}

                      {clientInfo.tracker ? (
                        <>
                          {clientInfo.tracker.gsm ? (
                            <Col xs={6} className="mt-1 mb-3">
                              <h6>{props.t("Tracker")}</h6>
                              <a href={"tel:" + clientInfo.tracker.gsm}>
                                {clientInfo.tracker.gsm}
                              </a>
                            </Col>
                          ) : null}
                        </>
                      ) : null}
                      {clientInfo.carephone ? (
                        <>
                          {clientInfo.carephone.gsm ? (
                            <Col xs={6} className="mt-1 mb-3">
                              <h6>{props.t("Safety phone")}</h6>
                              <a href={"tel:" + clientInfo.carephone.gsm}>
                                {clientInfo.carephone.gsm}
                              </a>
                            </Col>
                          ) : null}
                        </>
                      ) : null}
                      {clientInfo.videoCallRoomName ? (
                        <Col xs={6} className="mt-1  mb-3">
                          <h6>{props.t("Video call")}</h6>
                          <div>
                            <Link
                              to="#"
                              onClick={() => {
                                startVideoCall()
                              }}
                            >
                              {props.t("Start video call")}
                            </Link>
                          </div>
                        </Col>
                      ) : null}
                      {clientInfo.alarm_center_notices ? (
                        <Col xs={12} className="mt-1">
                          <h6>{props.t("Notices")}</h6>
                          <p>{clientInfo.alarm_center_notices}</p>
                        </Col>
                      ) : (
                        <></>
                      )}
                      {clientInfo.home_service_info ? (
                        <Col xs={12} className="mt-1  mb-3">
                          <h6>{props.t("Home help service")}</h6>
                          <p>{clientInfo.home_service_info}</p>
                        </Col>
                      ) : (
                        <></>
                      )}
                      {clientInfo.door_info ? (
                        <Col xs={6} className="mt-1  mb-3">
                          <h6>{props.t("Opening the door")}</h6>
                          <p>{clientInfo.door_info}</p>
                        </Col>
                      ) : (
                        <></>
                      )}
                      {clientInfo.alarm_center_procedure ? (
                        <Col xs={6} className="mt-1  mb-3">
                          <h6>{props.t("Procedure")}</h6>
                          <p>{clientInfo.alarm_center_procedure}</p>
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </CardBody>
                </Card>
              </>
            ) : null}
          </>
        ) : (
          <></>
        )}
      </Drawer>
    </>
  )
}

AlarmMonitoringDrawer.propTypes = {
  t: PropTypes.any,
  showDrawer: PropTypes.bool,
  setShowDrawer: PropTypes.any,
  selectedRow: PropTypes.any,
  setUpdateRequired: PropTypes.func,
}

export default withRouter(withTranslation()(AlarmMonitoringDrawer))
